export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    НС X 8005 — це сучасний гібрид соняшнику SUMO® екстенсивного типу, який поєднує високу стабільність, витривалість та відмінну адаптивність до різних умов вирощування. Гібрид створений для отримання стабільного врожаю навіть при обмежених ресурсах та в умовах кліматичних стресів.
                </p>
                <p className="card__description-text">
                    Він демонструє відмінні результати у широкому спектрі агрокліматичних зон та є надійним вибором для господарств із різним рівнем інтенсивності.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Основні переваги:
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності — до 5,7 т/га</li>
                    <li className="card__description-numbering">Стійкість до вовчка — A–G+</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стабільний результат у стресових умовах</li>
                    <li className="card__description-numbering">Пластичність до строків посіву</li>
                    <li className="card__description-numbering">Відмінні показники якості насіння</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид рекомендований для вирощування у Степу, Лісостепу та Поліссі України, демонструючи стабільні результати в різних кліматичних умовах.
                </p>
                <div className="card__description-title">Стійкість та агрономічні показники</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Енергія початкового росту — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 9/10</li>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-title">
                    Рекомендації щодо вирощування
                </p>
                <p className="card__description-text">
                    НС X 8005 — ідеальний гібрид для екстенсивного землеробства, але також добре реагує на підвищений агрофон. Рекомендується застосування гербіцидів системи SUMO® для ефективного контролю бур’янів.
                </p>
                <p className="card__description-text">
                    Гібрид підходить для господарств, які прагнуть отримати стабільний результат при мінімальних ризиках.
                </p>
                <p className="card__description-text">
                    НС X 8005 — це гібрид для тих, хто хоче надійність, стабільність і мінімальні ризики. Ідеальний варіант для екстенсивного землеробства та складних умов вирощування.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Стійкий до посухи та стресових умов</div>
                    <div className="aside__block">Пластичний до термінів посіву</div>
                    <div className="aside__block">Найкращі показники натури насіння в товарних посівах</div>
                </div>
            </div>
        </div>
    );
}
